import * as React from 'react';

import type { RenderElementProps } from 'slate-react';

const TableRow = ({ attributes, children }: RenderElementProps) => {
  return <tr {...attributes}>{children}</tr>;
};

export default TableRow;
